export const PAYSPRINT_PAYTM = 'PaysprintPaytm';
export const FINGPAY = 'Fingpay';
export const PAYSPRINT = 'PaySprint';
export const INSTANTPAY = 'Instantpay';
export const CREDOPAY = 'CredoPay';
export const EZYPAY = 'EzyPay';
export const ONECLICK = 'OneClick';
export const NSDLBANK = 'NSDLBank';
export const ONLYAPI = 'OnlyApi';
export const NSDL = 'NSDL';
